import React from "react";

const Error404 = () => {
  return (
    <>
      <h1>Error 404</h1>
      <p>The page you're looking for does not exist.</p>
    </>
  );
};

export default Error404;